module.exports = __webpack_public_path__ + "static/media/dolby.073b3b80.jpg";